<template>
  <transition name="visible">
  <md-card class="situation-card">
    <md-card-media md-ration="16:10">
      <div class="container">
        <img
            v-bind:class="{onlyPicture: myUsersLength < 1}"
            class="img-fluid"
            :src="getThumbnail()"
            :alt="mySituation.exposedUIHeader ? mySituation.exposedUIHeader : mySituation.name"
        />
        <div class="text-block" :class="{'text-block-short': myUsersLength < 1}">
          <h3 id="name">{{mySituation.name}}</h3>
        </div>
      </div>
    </md-card-media>
    <md-card-area v-if="myUsersLength >= 1">
      <md-card-expand>
        <md-card-content >
          <div id="actualAttendees">{{ $t('Zurzeit in diesem Raum:') }}</div>
          <div class="sc-users-container">
            <div class="userIcons"  v-for="u in myUsers" :key="u.id">
              <img class="userIcon" :src="getUserIcon(u)"/> 
              <span class="userName">{{u.getName()}}</span>
            </div>
          </div>
        </md-card-content>
      </md-card-expand>
    </md-card-area>
  </md-card>
  </transition>
</template>

<script>
import {mapGetters} from 'vuex';
import MediaManager from "@/api/MediaManager";
export default {
  props: ['situationID'],
  data: () => ({
    show: true,
    publicPath: process.env.BASE_URL
  }),
  methods:{
    getThumbnail() {
      let thumbnail;
      try {thumbnail = this.publicPath + "/media/" +this.panoramaTour.getName()+ "/" + this.mySituation.name.trim() + ".jpg";}
      catch (e){thumbnail = require("@/assets/panoramaThumbnail.jpg");}   
      return thumbnail;
    },
    gotoSituation() {
      this.$store.commit('handleGotoSituationTransition', { situationID: this.situationID } );
    },
    getUserIcon( u ) {
      return u.getUserIcon() ? u.getUserIcon() : MediaManager.getUserAvatar(u);
    }
  },
  computed: {
    ...mapGetters(['situations','currentSituation',"users", "panoramaTour"]),
    mySituation() {
      let situations = this.situations.filter( x => x.getSituationID() == this.situationID );
      if( situations && situations.length > 0 )
        return situations[0];
      return { name: "Unknown" };
    },
    myUsers(){
      let users = this.users.filter( x => x.getCurrentSituationID() == this.situationID);
      if( users && users.length > 0 )
        return users;     
      return false;
    },
    myUsersLength(){  
      let users = this.users.filter( x => x.getCurrentSituationID() == this.situationID);
      if(users)
        return users.length;     
      return 0;
    }
  },
}
</script>

<style lang="scss" scoped>
#actualAttendees{
  color: var(--primaryColor);
}
.sc-users-container{
  overflow-y: auto;
  max-height: 100px;
}
.md-card {
  width: 400px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
  border-radius: 5px;
}
.visible-enter-active{
  animation: open 0.3s ease-in;
}
.visible-leave-active{
  animation: close 0.3s ease-out;
}
@keyframes close {
  0% {opacity: 1;}
  100% {opacity: 0;}
}
@keyframes open {
  0% {opacity: 0;}
  100% {opacity: 1;}
}
.userIcons{
  margin: 5px 0 5px 0;
}
.userIcon {
  height: 25px;
  width: 25px;
  min-width: 25px;
  border-radius: 100%;
}
.userName {
  margin-left: 5px;
  margin-right: 5px;
}
.img-fluid {
  width: 400px;
  height: 250px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  cursor: pointer; 
}
.md-card-content{
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
.md-card-header, .md-card-content{
  background: #e5e5e5;
}
.situation-card .material-design-icon > .material-design-icon__svg {
  fill: var(--primaryColor);
}
.container {
  position: relative;
}
.onlyPicture{
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.text-block {
  width: 100%;
  position: absolute;
  bottom: -10px;
  left: 0px;
  background-color: rgba(1, 1, 1, 0.553);
  color: white;
  padding-left: 10px;
  padding-right: 10px;
}
.text-block-short {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  margin-bottom:  8px;
  padding-bottom: 0px;
}
.enterIcon{
  color: var(--primaryColor);
  right:10px ;
}
</style>